export default __webpack_public_path__ + "static/media/cross.53a62fd9.svg";